module.exports = __webpack_public_path__ + "img/folder-plus.45ff2235.svg";